export class CelebrationModalInfo {
  show: boolean = false;
  courseId: string = '';
}